(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.invest-earn-sell', ['pp.widgets-templates']);

ngModule.component('ppInvestEarnSell', {
    templateUrl: 'widgets/_angular/invest-earn-sell/invest-earn-sell.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);